import { Link, useLocation } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import { IconChevronDown, IconHamburger } from "../components/ui/Icons";
import { useClickOutside } from "../hooks/useClickOutside";
import logoKerin from "../assets/placeholders/logo_kerin_240x50.svg";

export default function Header({
  topTabs,
  activeTopTab,
  onNavigate,
  timelineItems,
  onTimelineNavigate,
  onOpenMenu
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const wrapRef = useRef(null);
  const location = useLocation();

  useClickOutside(wrapRef, () => setDropdownOpen(false), dropdownOpen);

  useEffect(() => {
    setDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 2);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const normalTabs = useMemo(
    () => topTabs.filter((item) => item !== "Ścieżka czasu" && item !== "Strona główna"),
    [topTabs]
  );

  const isHomeActive = location.pathname === "/";
  const isTimelineHome = location.pathname === "/sciezka-czasu";
  const isTimelineDetail = location.pathname.startsWith("/sciezka-czasu/");
  const isTimelineActive = isTimelineHome || isTimelineDetail || activeTopTab === "Ścieżka czasu";

  return (
    <header className={`topHeader ${scrolled ? "shadow" : ""}`}>
      <div className="topHeaderInner">
        <Link to="/" className="topLogo" aria-label="Subkowy Project, strona główna">
          <img src={logoKerin} alt="Subkowy Projekt Kerin" className="topLogoImg" />
        </Link>

        <nav className="topNavDesktop" aria-label="Menu główne">
          <button
            type="button"
            className={`topTab ${isHomeActive ? "active" : ""}`}
            onClick={() => onNavigate("Strona główna")}
          >
            Strona główna
          </button>

          <div className="navDropWrap" ref={wrapRef}>
            <button
              type="button"
              className={`topTab topTabDrop ${isTimelineActive || dropdownOpen ? "active" : ""}`}
              aria-haspopup="menu"
              aria-expanded={dropdownOpen}
              onClick={() => setDropdownOpen((value) => !value)}
            >
              <span>Ścieżka czasu</span>
              <span className={`chev ${dropdownOpen ? "up" : ""}`} aria-hidden="true">
                <IconChevronDown />
              </span>
            </button>

            {dropdownOpen && (
              <div className="navDropdown" role="menu" aria-label="Ścieżka czasu">
                <div className="navDropdownArrow" aria-hidden="true" />
                <div className="navDropdownGrid">
                  <button
                    type="button"
                    className={`navDropdownItem navDropdownHeading ${isTimelineHome ? "active" : ""}`}
                    onClick={() => {
                      setDropdownOpen(false);
                      onNavigate("Ścieżka czasu");
                    }}
                  >
                    Zobacz stronę główną osi czasu
                  </button>

                  {timelineItems.map((item) => {
                    const isActiveItem = location.pathname === `/sciezka-czasu/${item.slug}`;

                    return (
                      <button
                        key={item.slug}
                        type="button"
                        className={`navDropdownItem ${isActiveItem ? "active" : ""}`}
                        role="menuitem"
                        onClick={() => {
                          setDropdownOpen(false);
                          onTimelineNavigate(item.slug);
                        }}
                      >
                        {item.title}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {normalTabs.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`topTab ${activeTopTab === tab ? "active" : ""}`}
              onClick={() => onNavigate(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>

        <button
          type="button"
          className="topMobileTrigger"
          aria-label="Otwórz menu"
          onClick={onOpenMenu}
        >
          <span className="topIcon" aria-hidden="true">
            <IconHamburger />
          </span>
          <span className="topMobileLabel">Menu</span>
        </button>
      </div>
    </header>
  );
}